function changeEmailListStatus() {
    let element = $(this);
    let id_email_status = element.val();
    let form  = $('.check-item').closest('form');
 
    form.find('input[name="id_email_status"]').val(id_email_status);
    form.submit();
}

function checkAll(){
    let element = $(this);
    let form = element.closest('form');

    if(form.find('.checkbox-input:checked').length == 0){
        form.find('.checkbox-input').attr('checked', 'checked');
    }else{
        form.find('.checkbox-input').removeAttr('checked');
    }
}

$(document).on('change', '#id_email_status', changeEmailListStatus);
$(document).on('click', '.check-all', checkAll);